import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'
import i18next from 'i18next'

import { setTopNotificationBlockShown } from 'store/entities/localSettings/actions'
import { isTopNotificationBlockShown } from 'store/entities/localSettings/selectors'
import { setFeatureAsShown, updateUserActivity } from 'store/entities/identity/actions'
import { isShowFeatureSms, isDesktopNotificationsAvailable } from 'store/entities/identity/selectors'
import { getActivity } from 'store/entities/activity/selectors'
import Notification from './Notification'
import { CARRIER_ERRORS } from 'app/constants/phoneCountryCodes'

const mapStateToProps = createStructuredSelector({
  isTopNotificationBlockShown,
  isShowFeatureSms,
  isDesktopNotificationsAvailable,
  activity: getActivity,
})

const mapDispatchToProps = {
  setTopNotificationBlockShown,
  setFeatureAsShown,
  updateUserActivity,
}

export const parseCarrierResponse = res => {
  if (!res) {
    return {}
  }
  const t = res.toLowerCase()
  if (t.includes('invalid phone') || t.includes('No origination identity available to send to destination number')) {
    return {
      text: i18next.t(
        'user:The phone number provided does not seem to be valid. We updated your settings to email notifications. You can update your information'
      ),
      type: CARRIER_ERRORS.INVALID_PHONE,
    }
  }
  if (t.includes('opted out')) {
    return {
      text: i18next.t(
        'You have opted out to receive any notifications via your mobile number. To opt back in, please send a request to'
      ),
      type: CARRIER_ERRORS.OPTED_OUT,
    }
  }
  return {
    text: i18next.t(
      'We tried sending you notifications on your provided mobile number but were unable to do so. Please check your saved mobile number'
    ),
    type: CARRIER_ERRORS.DEFAULT,
  }
}

const mergeProps = ({ activity, ...stateProps }, { updateUserActivity, ...dispatchProps }, ownProps) => {
  const { userActivityId, showErrorMessage, committedSmsCarrierResponse, commitSmsCarrierResponse } = activity
  const response = committedSmsCarrierResponse || commitSmsCarrierResponse
  const errorObject = parseCarrierResponse(response)
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    showSMSError: {
      isShowSMSErrorMessage: showErrorMessage && errorObject.text && userActivityId,
      title: errorObject.text,
      type: errorObject.type,
      action: () => {
        updateUserActivity({ userActivityId, dto: { showErrorMessage: false } })
      },
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(withTranslation('user')(Notification))
